import { render } from "./DevelopmentCard.vue?vue&type=template&id=17363d94&ts=true"
import script from "./DevelopmentCard.vue?vue&type=script&lang=ts"
export * from "./DevelopmentCard.vue?vue&type=script&lang=ts"

import "./DevelopmentCard.vue?vue&type=style&index=0&id=17363d94&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__